var map = {
	"./back.svg": "965d",
	"./checkmark.svg": "93fc",
	"./checkmark_dark.svg": "4946",
	"./checkmark_white.svg": "7fb0",
	"./cross.svg": "fb81",
	"./cross_red.svg": "d099",
	"./cross_white.svg": "896b",
	"./duck.svg": "3c67",
	"./github.svg": "599e",
	"./instagram.svg": "3bb2",
	"./star.svg": "5dad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd78";